
import './Loading.css'

export default function Loading({ style, className, id }) {
    return <span className="loader"></span>
}